module.exports = __webpack_public_path__ + "img/37.5b68fe10.jpg";